import styled from "styled-components";

const StyledInput = styled.input`
  border: 1px solid #181818;
  color: #042f88 !important;
  padding: 12px;
  width: 100% !important;
  background-color: #f3f3f3;
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  height: 150px;
  border: 1px solid #181818 !important;
  background-color: #f3f3f3;
`;

const StyledButton = styled.button`
  background-color: #bc9a43;
  padding-inline: 30px;
  padding-block: 12px;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledForm = styled.form`
  margin-top: 150px;
`;

const StyledParagraph = styled.p`
  color: #bc9a43;
  font-size: 20px;
  font-weight: bold;
  padding-inline: 3px;
`;

const CustomComponents = {
  StyledInput,
  StyledTextArea,
  StyledButton,
  StyledForm,
  StyledParagraph,
};

export default CustomComponents;
